import React from 'react'
import styles from './MainTopHeader.module.scss'
import Close from 'svg/close-x.svg'
import UserIcon from 'svg/user.svg'
import SessionConnector, { ConnectorProps as SessionProps } from 'containers/Session'
import classNames from 'classnames'
import { useHeaderContext } from '../../HeaderContext'

const UserTopHeader = ({ fullName }: SessionProps) => {
  const { setSelectedCategory, setMobileHeaderConfig } = useHeaderContext()

  const closeAccountMenu = () => {
    setMobileHeaderConfig((previousMobileHeaderConfig) => ({
      ...previousMobileHeaderConfig,
      mobileMenuContent: 'null',
      mobileTopHeader: 'mainTopHeader',
      isMobileMenuOpen: false,
    }))
    setSelectedCategory(null)
  }

  const fullNameTruncated = fullName?.length > 35 ? fullName?.slice(0, 35).concat('...') : fullName

  return (
    <div className={styles.topHeaderMenuAccount}>
      <div onClick={closeAccountMenu}>
        <Close className={styles.closeIcon} />
      </div>
      <div className={styles.user}>
        <UserIcon className={styles.userIcon} />
        <p className={classNames('defaultTypographyH3', styles.userName)}>
          {fullNameTruncated ? fullNameTruncated : 'Log In / Register'}
        </p>
      </div>
    </div>
  )
}

export default SessionConnector(UserTopHeader)
